import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
import { Log, Level } from 'ng2-logger/client';

const log = Log.create('main.ts');

if (environment.production) {
  enableProdMode();
  Log.setProductionMode();
} else {
  log.i('Application is running in development mode');
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
